export default __webpack_public_path__ + "static/media/menuClose.cfbe95ee.svg";